import { type FC } from 'react';
import { IconButton } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { type OmitDeep } from 'type-fest';

import { PageHeader, type PageHeaderProps } from './page-header';

export type NestedPageHeaderProps = OmitDeep<
  PageHeaderProps,
  'navigationIcon'
> & {
  /**
   * Handler for app menu click
   */
  onNavigationIconClick: () => void;
};

export const NestedPageHeader: FC<NestedPageHeaderProps> = ({
  onNavigationIconClick,

  children,

  ...props
}) => (
  <PageHeader
    navigationIcon={
      <IconButton
        color="inherit"
        aria-label="menu"
        onClick={onNavigationIconClick}
        edge="start"
        sx={{ mr: 0.5 }}>
        <ChevronLeft fontSize="large" />
      </IconButton>
    }
    {...props}>
    {children}
  </PageHeader>
);
